import { ImportSource } from '@repo/database/browser';
/**
 * Ogni `ImportSource` appartiene a esattamente un gruppo: il pannello filtri
 * mostra i tre gruppi e invia al backend l'unione delle fonti selezionate
 * (`importSources`). Una nuova fonte va aggiunta qui, altrimenti il test di
 * copertura fallisce.
 */
export const CASH_MOVEMENT_SOURCE_GROUPS = {
    // PAYPAL_API: sync automatico dal collegamento diretto, come un conto bancario.
    bank: [ImportSource.ACUBE, ImportSource.FABRICK, ImportSource.PAYPAL_API],
    manual: [ImportSource.MANUAL],
    imported: [
        ImportSource.CSV_IMPORT,
        ImportSource.EXCEL_IMPORT,
        ImportSource.PDF_CARD_IMPORT,
        ImportSource.PDF_BANK_STATEMENT_IMPORT,
        ImportSource.PAYPAL_CSV,
    ],
};
/**
 * Stati selezionabili nel pannello filtri dei movimenti: combinati in OR fra
 * loro e in AND con gli altri filtri.
 */
export const CASH_MOVEMENT_FILTER_STATUSES = [
    'reconciled',
    'not_reconciled',
    'uncategorized',
    'internal_transfer',
];
//# sourceMappingURL=cash-movement-filters.js.map